// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3e0nv","validationTips":"StatementDescriptor_validationTips__2-dvo"};